/* global axios */
import ApiClient from './ApiClient';

class GowaAPI extends ApiClient {
  constructor() {
    super('gowa', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { gowa: data });
  }

  configure(inboxId, data) {
    return axios.patch(`${this.url}/${inboxId}`, { gowa: data });
  }

  pair(inboxId, pairingMethod = 'qr') {
    return axios.post(`${this.url}/${inboxId}/pair`, {
      pairing_method: pairingMethod,
    });
  }

  reconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reconnect`);
  }

  addAgents(inboxId, userIds) {
    return axios.post(`${this.url}/${inboxId}/agents`, { user_ids: userIds });
  }

  contactPresence(accountId, conversationId, signal) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/conversations/${conversationId}/gowa_presence`,
      {},
      { signal }
    );
  }

  groupInvite(conversationId, messageId, code, refresh = false) {
    const action = refresh ? 'gowa_group_invite_status' : 'gowa_group_invite';
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/messages/${messageId}/${action}`,
      { code }
    );
  }
}

export default new GowaAPI();
